import customAxios from '../../actions/customAxios';
import * as vehicleService from './vehicle.service';

// export const getInsCompanies = (auth) => {

//     return customAxios.get(`/vins/VInsV2/public/getProviders`);
// }

export const getVehicleMakes = (type) => {

    return customAxios.get(`/vins/VInsV2/public/getMakes?type=${type}`);
}

export const getVehicleModel = (type, make) => {

    return customAxios.get(`/vins/VInsV2/public/getModels?type=${type}&make=${make}`);
}

export const fetchRegProps = async (plate, talon) => {
  
      const params = `plate=${plate}&registrationId=${talon}`;
  
      const url = `/vins/VInsV2/public/getRegistrationData?${params}`;
  
      let res;
      try{
        res = await customAxios.get(url);
      } catch (error) {
        console.log(error);
      }
  
      let payload = {}
  
      if(res && res.data?.payload) {
  
        payload = vehicleService.mapRegistrationValues(res.data.payload);
  
        console.log('mappedData', payload);
  
      } else if (res && res.data?.messageCode && !res.data?.success) {
  
        payload = {messageCode: res.data?.messageCode}
        console.log(payload)
      }

      return payload;
    }

export const fetchLocationsByDistrict = async (plateCode) => {

  const urlLocations = `/syws-misc/api/address/locations?plate=${plateCode}`;

  return customAxios.get(urlLocations);
}

export const fetchMobilePhoneCode = async (phone, auth) => {

  const body = {
    "operation": "REQUEST_PHONE_VALIDATION",
    "mobTelephone": phone
  }

  const urlLocations = `/syws-auth/registration/signUp`;

  return customAxios.post(urlLocations, body);
}

export const signUp = async (body) => {

  const urlLocations = `/syws-auth/registration/signUp`;

  return customAxios.post(urlLocations, body);
}

export const addExistingPolicy = (plate, policyId, instTotal) => {
  instTotal = instTotal || 0;

  const params = `plate=${plate}&policyId=${policyId}&instTotal=${instTotal}`;

  const url = `syws-ins-vehicle/api/insVehicle/insContract/create?${params}`;

  return customAxios.get(url);
}

export const downloadFile = (fileUploadId) => {
  const url = `syws-file/file/download/${fileUploadId}`;

  const config = {responseType: 'blob'}

  return customAxios.get(url, config);
}

export const sendUserMessage = (data) => {
  const url = `syws-misc/api/userMessage`;

  const {prefMedia, subject, message, phoneNumber, email} = data;

  const body = {prefMedia, phoneNumber, email, subject, message};

  return customAxios.post(url, body);
}